
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pressrelease/[id]",
      function () {
        return require("private-next-pages/pressrelease/[id].tsx");
      }
    ]);
  